<script>
export default {
  props: {
    small: [Boolean, String],
    disabled: Boolean,
    invert: [Boolean, String],
    noOutline: [Boolean, String],
  },
  computed: {
    classes() {
      let classes = [];

      if (this.small) {
        classes.push('p-1 md_p-_75');
      } else {
        classes.push('p-1_5')
      }

      if (this.disabled) {
        classes.push('opacity-50 pointer-events-none');
      }

      if (this.invert) {
        classes.push(['border border-brand bg-white text-brand hover_bg-gray-100']);
      } else {
        classes.push(['bg-brand hover_bg-brand-900 text-white'])
      }

      if (this.noOutline) {
        classes.push('outline-none focus_outline-none focus_bg-brand-900');
      }

      return classes;
    },
  },
};
</script>

<template lang='pug'>
button.select-none.transition-bg.transition-250.w-full.font-bold.text-2xl.md_text-lg.md_font-normal.disabled_opacity-50.disabled_cursor-not-allowed(
  :class='classes',
  @click='disabled ? null : $emit("click")',
)
  slot
</template>

<style>
@import '~import/index';
</style>